// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__1zS3U","icon":"SortAdornment_icon__2HYzT","up":"SortAdornment_up__3BkIq","down":"SortAdornment_down__1tXu1","active":"SortAdornment_active__2fYGx"};